import { getScriptData } from './utils.m.js';
const { keepSessionAliveUrl, keepSessionAliveInterval } = getScriptData(import.meta.url, true);

if (typeof JJK !== 'undefined') {
	window.jjkError = new JJK.AjaxError();

	if (typeof JJK.SessionAliveKeeper !== 'undefined') {
		window.sessionKeeper = new JJK.SessionAliveKeeper({
			url: keepSessionAliveUrl,
			interval: keepSessionAliveInterval,
		});
	}
}
